import type { OrderStatus } from '@/features/order/domain/enums/OrderStatus'
import type { OrderLiveBranchEntity } from './OrderLiveBranchEntity'
import type { OrderLiveAddressEntity } from './OrderLiveAddressEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { OrderFulfillmentMethod } from '@/features/order/domain/enums/OrderFulfillmentMethod'
import type { OrderTag } from '@/features/trackOrder/domain/enums/OrderTag'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { OrderLiveAssignedDriverEntity } from './OrderLiveAssignedDriverEntity'
export class OrderLiveEntity {
  isNew?: boolean
  id?: string
  orderId?: string
  status?: OrderStatus
  branch?: OrderLiveBranchEntity
  address?: OrderLiveAddressEntity
  user?: UserMiniEntity
  hasActiveSearch?: boolean
  estimatedPreparationTime?: string | null
  hasSensitiveItem?: boolean
  createdAt?: string
  currentStatusSetAt?: string
  fulfillmentMethod?: OrderFulfillmentMethod
  referenceCode?: string
  tags?: OrderTag[]
  assignedDriver?: OrderLiveAssignedDriverEntity
  preparedAt?: string
  region?: RegionMiniEntity
  scheduledOrderTime?: string
}
